import Vue from 'vue';
import axios from 'axios';
import vueCookies from 'vue-cookies';
import VueProgressBar from 'vue-progressbar';
import ToggleButton from 'vue-js-toggle-button';
import VJstree from 'vue-jstree';
import router from '@/router';
import store from '@/store';
import i18n from '@/locale';
import vuetify from '@/plugins/vuetify';
import App from '@/vue-caas/App.vue';
import config from '@/vue-caas/config/config.js';
import validationUtils from '@/vue-dlb/utils/validationUtils';
import api from '@/vue-dlb/utils/backend-api';
import appUtil from '@/vue-dlb/utils/app-util';

require('@mdi/font/css/materialdesignicons.css');

require('@/vue-dlb/assets/scss/tailwind.scss');
require('@/vue-dlb/assets/font-awesome/css/all.css');
require('@/vue-dlb/assets/scss/style.scss');
require('@/vue-dlb/assets/scss/style-media.scss');
require('@/vue-dlb/assets/scss/theme-light.scss');
require('@/vue-dlb/assets/scss/theme-dark.scss');
require('@/vue-dlb/assets/css/vue-easytable.css');

import { VeTable } from 'vue-easytable';
import 'vue-easytable/libs/theme-default/index.css';

require('@/vue-dlb/assets/css/vue-easytable.css');
import { VTable, VPagination } from '@/vue-dlb/components/vue-easytable/libs';
import { loadState } from './vue-caas/utils/idb';

Vue.component(VTable.name, VTable);
Vue.component(VPagination.name, VPagination);

Vue.config.productionTip = false;
window.Store = store;
Vue.use(vueCookies);
Vue.use(VJstree);
Vue.use(ToggleButton);
Vue.use(VeTable);

Vue.prototype.$http = axios;
Vue.prototype.$homePage = !config.isDlb ? config.homePage : '/edimanager/srm';
Vue.prototype.api = api;
Vue.prototype.appUtil = appUtil;
Vue.prototype.validationUtils = validationUtils;
Vue.prototype.$auth = {
  search: false,
  manage: false,
};

const options = {
  color: '#2196f3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.1s',
    opacity: '0.5s',
    termination: 400,
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
};

Vue.use(VueProgressBar, options);

async function loadDataVuex() {
  const savedState = await loadState('my-vuex');

  if (savedState) {
    store.replaceState({
      ...store.state,
      ...savedState
    });
  }

  new Vue({
    el: '#app',
    vuetify,
    router,
    store,
    i18n,
    render: (h) => h(App),
  });
}

loadDataVuex();
